<template>
  <div class="point-not-enough">
    <h1 class="point-not-enough__title">ポイントを貯めて<br>もっとお得に</h1>
    <!-- POINT1 -->
    <div class="recommend-point">
      <div class="recommend-point__point">1</div>
      <div class="recommend-point__body">
        <h2 class="recommend-point__lead">サブスクリプションにご登録中の方は<br>毎月27ポイントが自動で付与されます</h2>
        <img src="/static/img/account/point1_b.svg" alt="登録中なら毎月27ptもらえる" class="recommend-point__image">
      </div>
    </div>
    <!-- POINT2 -->
    <div class="recommend-point">
      <div class="recommend-point__point">2</div>
      <div class="recommend-point__body">
        <h2 class="recommend-point__lead">購入額に応じて<br>5％分のポイントが付与されます</h2>
        <img src="/static/img/account/point2.svg" alt="100円につき5ptもらえる" class="recommend-point__image">
        <div class="recommend-point__foot">
          <dl class="shipping">
            <dt class="shipping__title">ポイント付与対象商品</dt>
            <dd class="shipping__data">超運2022年の運勢</dd>
          </dl>
        </div>
      </div>
    </div>
    <!-- POINT3 -->
    <div class="recommend-point">
      <div class="recommend-point__point">3</div>
      <div class="recommend-point__body">
        <h2 class="recommend-point__lead">貯めたポイントを<br>商品のお申し込みや購入に利用できます</h2>
        <img src="/static/img/account/point3.svg" alt="貯まったポイントで購入" class="recommend-point__image">
        <div class="recommend-point__foot">
          <dl class="shipping">
            <dt class="shipping__title">ポイント利用対象商品</dt>
            <dd class="shipping__data">超運2022年の運勢</dd>
          </dl>
          <ul class="note">
            <li class="note__item">※全額をポイントで支払う場合のみ利用可能です。（商品代金の一部をポイントで支払うことはできません。）</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PointNotEnough',
}
</script>

<style lang="scss" scoped>
@import '../../../../sass/commons/commonVariables.scss';

.point-not-enough {
  border-top: 1px solid #DCDFE2;
  margin: 0 -16px;
  padding: 35px 20px 40px;
  &__title {
    font-weight: bold;
    font-size: 26px;
    line-height: 1.3;
    text-align: center;
    margin: 0 0 23px;
  }
}
.recommend-point {
  margin: 0 0 25px;
  &:last-child {
    margin-bottom: 0;
  }
  &__point {
    display: table;
    width: 50px;
    height: 50px;
    margin: 0 auto -25px;
    font-family: "DIN Alternate";
    color: $col_white;
    font-size: 24px;
    font-weight: bold;
    line-height: 1;
    text-align: center;
    background: linear-gradient(135deg, #FF7497 18.23%, #CB8BFF 80.21%);
    border-radius: 50px;
    position: relative;
    z-index: 1;
    &::before {
      content: 'POINT';
      display: block;
      margin: 10px 0 0;
      font-size: 10px;
    }
  }
  &__body {
    margin: 0;
    padding: 40px 20px 20px;
    background: linear-gradient(64.31deg, rgba(#FF7497, 0.07) 18.23%, rgba(#CB8BFF, 0.07) 80.21%);
    border-radius: 10px;
  }
  &__lead {
    margin: 0 0 5px;
    font-weight: bold;
    font-size: 16px;
    text-align: center;
  }
  &__image {
    display: table;
    margin: 0 auto;
    max-width: 100%;
  }
  &__foot {
    padding: 25px 0 0;
    &::before {
      content: '';
      display: block;
      margin: 0 0 16px;
      height: 1px;
      background: linear-gradient(3.2deg, #FF7497 21.4%, #CB8BFF 76.64%);
    }
  }
}
.shipping {
  margin: 0;
  padding: 0;
  font-size: 13px;
  &__title {
    color: #FF7497;
    font-weight: bold;
    margin: 0 0 2px;
  }
  &__data {
    margin: 0;
  }
}
.note {
  font-size: 11px;
  color: #656D78;
  margin: 0;
  padding: 0;
  &__item {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/User/PointNotEnough.vue